const currentYear = new Date().getFullYear();

const jdonLd = {
  '@context': 'http://schema.org',
  '@type': 'WebSite',
  url: 'https://www.paidy.com/organic',
  image: 'https://paidy.com/dist/paidy-logo-noshadow.svg',
  headline: 'Paidy | Organic',
  author: 'Paidy Inc.',
  copyrightHolder: 'Paidy Inc.',
  copyrightYear: currentYear,
  encodings: 'UTF-8',
  description:
    'クレカ・事前登録不要。メールアドレスと携帯電話番号でお買い物。Paidy（ペイディー）翌月払いは、メールアドレスと携帯電話番号でカンタンにお買い物ができる、新しいあと払い。お支払いは翌月にコンビニ、銀行で。あと払い可能な、キャッシュレス決済サービスです。',
  keywords: [
    'Paidy',
    '瞬間アトバライ',
    '瞬間',
    'campaign',
    '買い物',
    '決済',
    'コンビニ',
    'クレカ',
    '後払い',
    'あと払い',
    '支払い',
    'EC',
    '代引き',
    '通販',
    'システム',
    '導入',
    '翌月',
    '新木優子',
  ].join(','),
  locationCreated: {
    address: {
      addressCountry: '日本',
      addressRegion: '東京都',
      postalCode: '107-6212',
      streetAddress: '港区赤坂9-7-1 ミッドタウン・タワー 12階',
    },
  },
};

export default jdonLd;
